import { render, staticRenderFns } from "./LightConstructiveElementContractAmountList.vue?vue&type=template&id=5d8fddc0&scoped=true&"
import script from "./LightConstructiveElementContractAmountList.vue?vue&type=script&lang=js&"
export * from "./LightConstructiveElementContractAmountList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8fddc0",
  null
  
)

export default component.exports